import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'; // Importation des modules nécessaires depuis Angular
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'; // Importation des modules pour la construction de formulaires réactifs
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, map, startWith } from 'rxjs';


@Component({
  selector: 'app-add-update-formulaire',
  templateUrl: './add-update-formulaire.component.html',
  styleUrls: ['./add-update-formulaire.component.scss']
})
export class AddUpdateFormulaireComponent implements OnInit {
  @Input() fields: any[] = []; // Déclaration d'une propriété d'entrée pour les champs du formulaire
  form!: FormGroup; // Initialisation d'une variable pour stocker le formulaire
  @Output() submit: EventEmitter<any> = new EventEmitter<any>(); // Déclaration d'un événement de sortie pour la soumission du formulaire
  /* -------------------------------------------------------------------------- */
  /*                               MatAutoComplete                              */
  /* -------------------------------------------------------------------------- */
  selectedOption!: FormControl;
  myControl = new FormControl<string | { value: string, label: string }>(this.data.matDefaultValue);
  options!: { value: string, label: string }[];

  filteredOptions!: Observable<{ value: string, label: string }[]>;
  /* -------------------------------------------------------------------------- */
  /*                             End MatAutoComplete                            */
  /* -------------------------------------------------------------------------- */

  /**
   * Upload de fichier
   */
  selectedFileName: string = ''; //Uploader l'image
  selectedFile!: File; //Pour ajouter un fichier 
  onFileSelected(event: any): void {
    this.selectedFile = event.target.files[0];
    if (this.selectedFile) {

      this.selectedFileName = this.selectedFile.name;

      // Faites quelque chose avec le fichier, par exemple, téléchargez-le vers le serveur
    }
  }
  /**
   * End upload de fichier
   */

  /**
   * 
   * @param fb 
   * @param dialogRef 
   * @param data 
   * 
   * Paramètre data contient plusieurs objets:
   * 1. label:
   * Il s'agit du label de la boite de dialogue
   * 
   * 2. type
   * Il prend deux valeurs possible: 'add' ou 'update'. Celà permet de savoir si c'est un ajour ou modification
   * 
   * 3. file
   * Cela vaut true s'il existe un champs de type file parmi les champs
   * 
   * 4. matAutoComplete
   * Cela vaut true s'il y'a un champs de type matAutoComple parmi les champs
   * 
   * 5. matDefaultValue
   * Il s'agit de la valeur par défaut à mettre dans le champs du matAutoComplete
   * 
   * 6. field
   * field est un tableau comportant les propriétés d'entrée pour les champs de formulaire
   * 
   * 
   * ************** Détails des champs de field ----------
   * label : Il s'agit du libelle à donner au champs
   * name : Il s'agit de la valeur à mettre au niveau du formControlName
   * value : Ce champs vaut "" s'il s'agit d'un ajour, et prend une valeur 
   * type: Cela prend le type du champs du formulaire . Ex: text
   * placeholder
   * 
   * 
   * 
   * Ex de donnée:
   * fields = [

      { label: 'Nom', name: 'nom', value="", type: 'text', placeholder: 'Ex: Joe Dohn' },
      { label: 'Téléphone', name: 'telephone', value="", type: 'text', placeholder: 'Ex: 61616161' },
      { label: 'Salaire', name: 'salaire' value="",, type: 'text', placeholder: 'Ex: 120000' },
      { label: 'Mot de passe', name: 'MotDePasse', value="", type: 'password', placeholder: 'Saisissez un mot de passe pour l\'utilisateur ' },
      {
        label: 'Type utilisateur', // Libellé du champ
        name: 'typeUtilisateur', // Nom du champ pour le formControlName
        type: 'select', // Type du champ (select),
        value="", //Valeur du champs
        options: [ // Options du select
          { value: 'Conducteur', label: 'Conducteur' }, // Première option avec sa valeur et son libellé
          { value: 'Comptable', label: 'Comptable' }, // Deuxième option avec sa valeur et son libellé
        ],
        placeholder: 'Sélectionnez une type utilisateur' // Placeholder du select
      }
       {
        label: 'Type utilisateur', // Libellé du champ
        name: 'typeUtilisateur', // Nom du champ pour le formControlName
        type: 'matAutoComplete', // Type du champ (select),
        value="", //Valeur du champs
        options: [ // Options du select
          { value: 'Conducteur', label: 'Conducteur' }, // Première option avec sa valeur et son libellé
          { value: 'Comptable', label: 'Comptable' }, // Deuxième option avec sa valeur et son libellé
        ],
        placeholder: 'Sélectionnez une type utilisateur' // Placeholder du select
      }
      // Ajoutez d'autres champs ici
    ];
   */

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddUpdateFormulaireComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { } // Injection du FormBuilder dans le constructeur pour la construction du formulaire

  ngOnInit(): void {
    this.filteredOptions = this.data.options;
    this.selectedOption = new FormControl('');
    this.form = this.createFormGroup(); // Appel de la méthode pour créer le formulaire lors de l'initialisation
  }

  createFormGroup(): FormGroup {

    const data: { [key: string]: any } = {}; // Initialize data as object with string keys

    //Si on a un champs de type matAutoComplete
    if (this.data.matAutoComplete == true) {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => {
          const label = typeof value === 'string' ? value : value?.label;
          return label ? this._filter(label as string) : this.options.slice();
        }),
      );

    }
    this.data.fields.forEach((field: any) => {
      //Si on a un champ  matAutoComplete, on rempli la variable this.options de l'array options dispo dans le field matAutoComplete
      if(field.type == "matAutoComplete" && this.data.matAutoComplete == true){
        this.options = field.options;
      }

      
      if (field.type != "file" && field.type != "matAutoComplete") {
        const validators = (field.required !== undefined ? field.required : true) ? [Validators.required] : [];
        data[field.name] = [field.default_value, validators];
      }

    });

    const formGroup = this.fb.group(data);

    return formGroup;
  }

  /* -------------------------------------------------------------------------- */
  /*                               MatAutoComplete                              */
  /* -------------------------------------------------------------------------- */
  onSelected(event: MatAutocompleteSelectedEvent) {
    const selectedOption = event.option.value;
    if (selectedOption) {
      const selectedLabel = selectedOption.label;
      this.selectedOption = selectedLabel;
    }
  }
  displayFn(option: {value: string, label: string}): string {
    return option && option.label ? option.label : '';
  }

  private _filter(option: string): {value: string, label: string}[] {
    const filterValue = option.toLowerCase();

    return this.options.filter(option => option.label.toLowerCase().includes(filterValue));
  }

  /* -------------------------------------------------------------------------- */
  /*                             End matAutoComplete                            */
  /* -------------------------------------------------------------------------- */

  onCancel(): void {
    this.dialogRef.close();
  }
  onSubmit() {
    //this.submit.emit(this.form.value); // Émission de l'événement 'submit' avec les valeurs du formulaire

    if (this.data.file == true) {
      const file: File = this.selectedFile;
      this.form.value["image"] = file;
      

    }

    if (this.data.matAutoComplete == true) {
      this.form.value["selectedOption"] = this.selectedOption;
    }
    this.dialogRef.close(this.form.value);

  }
}
